import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Asset } from '../../asset/Asset'

@InputType()
export class GetProductAssetsArgs extends ActionArgs {
  // Server-only, never exposed in the schema (same shape as ActionArgs.user): the product's stored assets.
  assets?: Asset[]

  @Field(() => Boolean, { nullable: true })
  includeAllStatuses?: boolean
}

export interface IGetProductAssets extends IAction<Asset[], GetProductAssetsArgs> {}
